// extracted by mini-css-extract-plugin
export default {"source":"news-source_source__PDdLq","source__button":"news-source_source__button__X90oh","source__actions":"news-source_source__actions__iKvkP"};